module.exports = __webpack_public_path__ + "img/business_prod_dev.246f4cbd.png";